/**
 * @generated SignedSource<<2d82451401d014befc5d4ec1bd8b47f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddIncludeAllUserDispatchConditionInput = {
  clientMutationId?: string | null;
  messageDispatchId: string;
};
export type useDispatchConditions_AddIncludeAllUsersDispatchConditionMutation$variables = {
  input: AddIncludeAllUserDispatchConditionInput;
};
export type useDispatchConditions_AddIncludeAllUsersDispatchConditionMutation$data = {
  readonly Admin: {
    readonly Message: {
      readonly addIncludeAllUserDispatchCondition: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type useDispatchConditions_AddIncludeAllUsersDispatchConditionMutation = {
  response: useDispatchConditions_AddIncludeAllUsersDispatchConditionMutation$data;
  variables: useDispatchConditions_AddIncludeAllUsersDispatchConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "AddIncludeAllUserDispatchConditionPayload",
            "kind": "LinkedField",
            "name": "addIncludeAllUserDispatchCondition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDispatchConditions_AddIncludeAllUsersDispatchConditionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDispatchConditions_AddIncludeAllUsersDispatchConditionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "03505e9681715990a075b3833ffdd31c",
    "id": null,
    "metadata": {},
    "name": "useDispatchConditions_AddIncludeAllUsersDispatchConditionMutation",
    "operationKind": "mutation",
    "text": "mutation useDispatchConditions_AddIncludeAllUsersDispatchConditionMutation(\n  $input: AddIncludeAllUserDispatchConditionInput!\n) {\n  Admin {\n    Message {\n      addIncludeAllUserDispatchCondition(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "06b300465b9e4442c604601be1e1846a";

export default node;
